import React from 'react';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import RebateSection from './RebateSection';

const RebatePage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#1A0000]" data-testid="rebate-page">
      {/* Header */}
      <header className="bg-[#0D0D0D] border-b border-red-900/30 sticky top-0 z-50">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-3 md:py-4">
          <div className="flex items-center justify-between">
            <button
              onClick={() => navigate('/')}
              data-testid="rebate-page-back-btn"
              className="flex items-center space-x-2 text-white/70 hover:text-white transition-colors"
            >
              <ArrowLeft className="w-5 h-5" />
              <span className="font-medium text-sm">Kembali</span>
            </button>
            <img
              src="https://www.perodua.com.my/assets/images/logo.png"
              alt="Perodua"
              className="h-7 md:h-8 brightness-0 invert opacity-80"
            />
          </div>
        </div>
      </header>

      {/* Rebate Section */}
      <RebateSection />

      {/* Footer */}
      <footer className="bg-[#0D0D0D] border-t border-red-900/30 py-5">
        <div className="max-w-7xl mx-auto px-4 text-center">
          <p className="text-white/30 text-xs">
            Harga dan rebate tertakluk kepada perubahan tanpa notis. Syasyah Aran - Perodua Sales Advisor.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default RebatePage;
